/* Apex product zoom lightbox — clean white edition
   - Fullscreen white modal, round close button, bottom ‹ 4/10 › pill nav
   - Smooth open, point zoom (dbl-click / double-tap / wheel), drag pan,
     two-finger pinch, swipe navigation. */
(function () {
  if (window.__apexZoom) return;
  window.__apexZoom = true;

  var state = { items: [], idx: 0, scale: 1, tx: 0, ty: 0, open: false };
  var el = {};

  function sized(url, w) {
    try {
      var u = new URL(url, location.href);
      u.searchParams.set('width', w);
      return u.href;
    } catch (e) { return url; }
  }

  function biggest(img) {
    var ss = img.getAttribute('srcset');
    if (ss) {
      var parts = ss.split(',');
      var last = parts[parts.length - 1].trim().split(/\s+/)[0];
      if (last) return sized(last, 1800);
    }
    return sized(img.currentSrc || img.src, 1800);
  }

  function collect() {
    var items = [], seen = {};
    document.querySelectorAll('.product__media-list .product__media-item img').forEach(function (img) {
      var full = biggest(img);
      var key = full.split('?')[0];
      if (!full || seen[key]) return;
      seen[key] = 1;
      items.push({ full: full, alt: img.alt || '' });
    });
    return items;
  }

  function build() {
    if (el.overlay) return;
    var o = document.createElement('div');
    o.className = 'apex-zoom';
    o.innerHTML =
      '<button type="button" class="apex-zoom__close" aria-label="Close">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>' +
      '<div class="apex-zoom__stage"><img class="apex-zoom__img" alt="" draggable="false"></div>' +
      '<div class="apex-zoom__pill">' +
      '<button type="button" class="apex-zoom__nav apex-zoom__nav--prev" aria-label="Previous">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg></button>' +
      '<span class="apex-zoom__counter"></span>' +
      '<button type="button" class="apex-zoom__nav apex-zoom__nav--next" aria-label="Next">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></button>' +
      '</div>';
    document.body.appendChild(o);
    el.overlay = o;
    el.stage = o.querySelector('.apex-zoom__stage');
    el.img = o.querySelector('.apex-zoom__img');
    el.counter = o.querySelector('.apex-zoom__counter');
    bindOverlay();
  }

  function apply(animate) {
    el.img.classList.toggle('no-anim', animate === false);
    el.img.style.transform = 'translate(' + state.tx + 'px,' + state.ty + 'px) scale(' + state.scale + ')';
    el.overlay.classList.toggle('is-zoomed', state.scale > 1.02);
  }

  function clampPan() {
    var r = el.stage.getBoundingClientRect();
    var maxX = (r.width * (state.scale - 1)) / 2;
    var maxY = (r.height * (state.scale - 1)) / 2;
    state.tx = Math.max(-maxX, Math.min(maxX, state.tx));
    state.ty = Math.max(-maxY, Math.min(maxY, state.ty));
  }

  function resetZoom(animate) {
    state.scale = 1; state.tx = 0; state.ty = 0;
    apply(animate);
  }

  function zoomTo(scale, cx, cy) {
    var r = el.stage.getBoundingClientRect();
    var prev = state.scale;
    scale = Math.max(1, Math.min(4, scale));
    if (scale === prev) return;
    var px = cx - r.left - r.width / 2;
    var py = cy - r.top - r.height / 2;
    state.tx = px - (scale / prev) * (px - state.tx);
    state.ty = py - (scale / prev) * (py - state.ty);
    state.scale = scale;
    if (scale <= 1.02) { resetZoom(); return; }
    clampPan();
    apply();
  }

  function show(i, dir) {
    var n = state.items.length;
    state.idx = ((i % n) + n) % n;
    var item = state.items[state.idx];
    resetZoom(false);
    el.img.classList.add('is-loading');
    if (dir) el.img.classList.add(dir > 0 ? 'slide-left' : 'slide-right');
    var pre = new Image();
    pre.onload = function () {
      el.img.src = item.full;
      el.img.alt = item.alt;
      requestAnimationFrame(function () {
        el.img.classList.remove('is-loading', 'slide-left', 'slide-right');
      });
    };
    pre.src = item.full;
    el.counter.textContent = (state.idx + 1) + ' / ' + n;
  }

  function open(startIdx) {
    if (!state.items.length) return;
    build();
    state.open = true;
    document.documentElement.classList.add('apex-zoom-open');
    el.overlay.classList.add('is-open');
    show(startIdx || 0);
  }

  function close() {
    if (!state.open) return;
    state.open = false;
    el.overlay.classList.remove('is-open', 'is-zoomed');
    document.documentElement.classList.remove('apex-zoom-open');
  }

  /* ── Overlay interactions ── */
  function bindOverlay() {
    el.overlay.querySelector('.apex-zoom__close').addEventListener('click', close);
    el.overlay.querySelector('.apex-zoom__nav--prev').addEventListener('click', function () { show(state.idx - 1, -1); });
    el.overlay.querySelector('.apex-zoom__nav--next').addEventListener('click', function () { show(state.idx + 1, 1); });

    document.addEventListener('keydown', function (e) {
      if (!state.open) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(state.idx - 1, -1);
      if (e.key === 'ArrowRight') show(state.idx + 1, 1);
    });

    var lastTap = 0;
    el.stage.addEventListener('dblclick', function (e) {
      e.preventDefault();
      zoomTo(state.scale > 1.02 ? 1 : 2.5, e.clientX, e.clientY);
    });

    el.stage.addEventListener('wheel', function (e) {
      e.preventDefault();
      zoomTo(state.scale * (e.deltaY < 0 ? 1.15 : 0.87), e.clientX, e.clientY);
    }, { passive: false });

    var pointers = new Map();
    var start = null, pinchStart = null;

    el.stage.addEventListener('pointerdown', function (e) {
      el.stage.setPointerCapture(e.pointerId);
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pointers.size === 1) {
        start = { x: e.clientX, y: e.clientY, tx: state.tx, ty: state.ty, t: Date.now(), moved: false };
        if (e.pointerType === 'touch') {
          var now = Date.now();
          if (now - lastTap < 320) {
            zoomTo(state.scale > 1.02 ? 1 : 2.5, e.clientX, e.clientY);
            lastTap = 0;
            return;
          }
          lastTap = now;
        }
      } else if (pointers.size === 2) {
        var pts = Array.from(pointers.values());
        pinchStart = {
          d: Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y),
          scale: state.scale,
          cx: (pts[0].x + pts[1].x) / 2,
          cy: (pts[0].y + pts[1].y) / 2
        };
      }
    });

    el.stage.addEventListener('pointermove', function (e) {
      if (!pointers.has(e.pointerId)) return;
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pointers.size === 2 && pinchStart) {
        var pts = Array.from(pointers.values());
        var d = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
        zoomTo(pinchStart.scale * (d / pinchStart.d), pinchStart.cx, pinchStart.cy);
        return;
      }
      if (!start) return;
      var dx = e.clientX - start.x, dy = e.clientY - start.y;
      if (Math.abs(dx) > 4 || Math.abs(dy) > 4) start.moved = true;
      if (state.scale > 1.02) {
        state.tx = start.tx + dx;
        state.ty = start.ty + dy;
        clampPan();
        apply(false);
      }
    });

    function pointerEnd(e) {
      if (!pointers.has(e.pointerId)) return;
      pointers.delete(e.pointerId);
      if (pointers.size < 2) pinchStart = null;
      if (pointers.size === 0 && start) {
        var dx = e.clientX - start.x;
        var dt = Date.now() - start.t;
        if (state.scale <= 1.02 && Math.abs(dx) > 55 && dt < 600) {
          show(state.idx + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
        }
        start = null;
        apply();
      }
    }
    el.stage.addEventListener('pointerup', pointerEnd);
    el.stage.addEventListener('pointercancel', pointerEnd);
  }

  /* ── Gallery click interception (capture phase beats Dawn's modal) ── */
  document.addEventListener('click', function (e) {
    var mediaItem = e.target.closest('.product__media-list .product__media-item');
    if (!mediaItem || e.target.closest('.deferred-media__poster-button, video, iframe, model-viewer')) return;
    var img = mediaItem.querySelector('img');
    if (!img) return;
    e.preventDefault();
    e.stopPropagation();
    var items = collect();
    var key = biggest(img).split('?')[0];
    var idx = 0;
    items.forEach(function (it, i) { if (it.full.split('?')[0] === key) idx = i; });
    state.items = items;
    open(idx);
  }, true);
})();
